var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['c--tabs_route-switcher-tabs', 'route-switcher-tabs noselect', {
      'active-white': _vm.isActiveWhite
    }]
  }, [_c('ul', _vm._l(_vm.tabs, function (tab, index) {
    return _c('li', {
      key: `route-switcher-tabs-${index}`,
      attrs: {
        "data-testid": `${tab.text}-tab`
      }
    }, [_c('nuxt-link', {
      class: {
        'active-tab': tab.route.name === _vm.activeTabRouteName
      },
      attrs: {
        "to": _vm.localePath(tab.route)
      }
    }, [_vm._v("\n        " + _vm._s(tab.text) + "\n      ")])], 1);
  }), 0)]);

}
var staticRenderFns = []

export { render, staticRenderFns }